import React, { useState, useEffect } from "react";
import axios from "axios";
import Menu from "../Menu";
import DialogBox from "../../components/DialogBox";
import Pagination from "../components/Pagination";

const HealthPackage = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedData, setSelectedData] = useState("");
    const [pageNo, setPageNo] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    const [hasMore, setHasMore] = useState(true);
    const [totalItems, setTotalItems] = useState(0);

    // Helper to get cookie
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
    }

    const token = getCookie("token");
    const userid = getCookie("userid");

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                "https://api.dqr-display-tms.eventum.co.in/api/DeviceInfoHistory/Search",
                {
                    ispageload: true,
                    pagesize: pageSize,
                    currentpageno: pageNo,
                    withoutpagination: false,
                    pagedirection: "frist"
                },
                {
                    headers: {
                        "Content-Type": "application/json-patch+json",
                        "accept": "text/plain",
                        "X-Authorization": token,
                        "UserId": userid || "1",
                    },
                }
            );

            if (response.data && Array.isArray(response.data.data)) {
                setData(response.data.data);
                const rows = response.data.data;
                setHasMore(rows.length === pageSize);
                const approximateTotal = (pageNo * pageSize) + rows.length + (rows.length === pageSize ? pageSize : 0);
                setTotalItems(approximateTotal);
            } else {
                setData([]);
                setHasMore(false);
                setTotalItems(0);
            }
        } catch (error) {
            console.error("Error fetching health package data:", error);
            setData([]);
            setHasMore(false);
            setTotalItems(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [pageNo, pageSize]);

    const handleShowData = (dataText) => {
        setSelectedData(dataText);
        setShowModal(true);
    };

    const handlePageChange = (page) => {
        setPageNo(page - 1);
    };

    const handleItemsPerPageChange = (newItemsPerPage) => {
        setPageSize(newItemsPerPage);
        setPageNo(0);
    };

    const totalPages = hasMore ? pageNo + 2 : pageNo + 1;

    return (
        <>
            <Menu />
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="d-flex justify-content-between align-items-center w-100">
                                <h1 className="mb-0">Health Package</h1>
                                <button
                                    className="btn btn-primary"
                                    onClick={fetchData}
                                >
                                    Refresh
                                </button>
                            </div>
                        </div>
                    </section>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="card">
                                <div className="card-body table-responsive p-0">
                                    <table className="table table-hover table-striped text-nowrap">
                                         <thead className="" style={{
                            backgroundColor: 'var(--surface2)',
                            color: 'var(--text)',
                            borderColor: 'var(--border)'
                          }}>
                                            <tr>
                                                <th>ID</th>
                                                <th>Created Date</th>
                                                <th>Pos Name</th>
                                                <th>Merchant ID</th>
                                                <th>Serial No</th>
                                                <th>Type</th>
                                                <th>Data</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="7" className="text-center p-4">
                                                        <div className="spinner-border text-primary" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : data.length > 0 ? (
                                                data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.id}</td>
                                                        <td>{item.createddate}</td>
                                                        <td>{item.posname}</td>
                                                        <td>{item.merchantid}</td>
                                                        <td>{item.serialno}</td>
                                                        <td>
                                                            <span className="badge badge-info">{item.type}</span>
                                                        </td>
                                                        <td
                                                            style={{
                                                                maxWidth: "300px",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                cursor: "pointer",
                                                                color: "blue",
                                                                textDecoration: "underline"
                                                            }}
                                                            title="Click to view full data"
                                                            onClick={() => handleShowData(item.data)}
                                                        >
                                                            {item.data}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center">No data found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                
                                <Pagination
                                    currentPage={pageNo + 1}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                    itemsPerPage={pageSize}
                                    onItemsPerPageChange={handleItemsPerPageChange}
                                    totalItems={totalItems}
                                    showPageNumbers={false}
                                    showItemsPerPageSelector={true}
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            {showModal && (
                <DialogBox
                    currentText={
                        <div style={{ wordBreak: "break-all", maxHeight: "60vh", overflowY: "auto" }}>
                            {selectedData}
                        </div>
                    }
                    setModalForText={setShowModal}
                />
            )
            }
        </>
    );
};

export default HealthPackage;
